import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { KsRecoveryFlag, KsRecoverySeverity } from '../../core/ops/ops-recovery.types';
import { IconComponent } from '../icon/icon';

/** DOC-52 §1 severity, in the decision-maker's words rather than the enum's. */
const SEVERITY_LABELS: Record<KsRecoverySeverity, string> = {
  ATTENTION: 'Attention',
  SERIOUS: 'Serious',
};

/**
 * DOC-52 — Cross-facility Kickstart recovery decision-input flag (BRE-410).
 *
 * Non-blocking, informational banner rendered at Ops decision points when the
 * client has an active KS recovery state (ks_recovery_signal ≠ KS_CLEAR).
 * Renders nothing when `flag` is null (KS_CLEAR).
 *
 * Severity:
 *   ATTENTION → amber (warning-banner token)
 *   SERIOUS   → red/elevated (error-banner token)
 *
 * Ops-only — never import into a client-facing component.
 */
@Component({
  selector: 'app-ops-recovery-flag',
  imports: [IconComponent],
  templateUrl: './ops-recovery-flag.html',
  styleUrl: './ops-recovery-flag.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OpsRecoveryFlagComponent {
  readonly flag = input<KsRecoveryFlag | null>(null);

  /** Falls back to the raw severity rather than rendering an empty badge. */
  protected readonly severityLabel = computed(() => {
    const severity = this.flag()?.severity;
    return severity ? (SEVERITY_LABELS[severity] ?? severity) : '';
  });
}
